import { UrlConstants } from "src/app/shared/constants/url.constants";
export class ApiSearchConstants {
    static URL = UrlConstants.API_V2 + "Search";
    static FUNCTION_SEARCH = "Search";
    static FUNCTION_GET_SEARCH_LAYER_FIELDS = "GetSearchLayerFields";
}
